module.exports = (nodes) => {
  return nodes.reduce((offsets, node) => {
    return node.hasOwnProperty('offset')
      ? [ ...offsets, node.offset ]
      : offsets
  }, [])
}



// WEBPACK FOOTER //
// ../node_modules/vqua/lib/virtual/filterNodesOffsets.js